import axios from "axios";
import { getToken } from "../utils";
import { showLoading as showAppLoading, hideLoading } from '@/utils/loading';
export const baseUrl = 'https://disbursements.ecoremedia.net'; //测试环境

const service = axios.create({
  baseURL: baseUrl,
  timeout: 3600000 // request timeout
});
// request interceptor
service.interceptors.request.use(config => {
  // do something before request is sent
  if (getToken()) {
    config.headers["access-token"] = getToken();
    config.headers["token"] = getToken();
    config.headers["user-id"] = localStorage.getItem("id");
    config.headers["uid"] = localStorage.getItem("id");
  }
  const showLoading = config.myConfig?.showLoading === true;
  // 🔥 打标：这个请求是否参与 loading 计数
  config.__useLoading = showLoading;
  if (showLoading) {
    showAppLoading();
  }
  return config;
}, error => {
  const showLoading = error.config?.__useLoading;
  if (showLoading) {
    hideLoading(); // -1
  }
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(response => {
  // 🔥 只对参与 loading 的请求 hide
  if (response.config.__useLoading) {
    hideLoading(); // -1
  }
  const res = response.data;
  if (response.headers["content-disposition"] != undefined) {
    localStorage.setItem("file_name", response.headers["content-disposition"]);
  }
  const result = res.code;
  if (result === undefined) {
    return response;
  }
  if (result !== 0 && result !== 1) {
    // if (res.code == 443) {
    //   router.push({
    //     path: "/",
    //   });
    // }
  }
  return res;
}, error => {
  if (error.config?.__useLoading) {
    hideLoading(); // -1
  }
  ElMessage({
    message: error.message,
    type: "error",
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;